import React from 'react';
import { Icon, Menu } from 'semantic-ui-react';

import './toc.css';
import { TocContext } from '../contexts/TocContext';

import { HeaderItem } from '../components/DataTypes';
// import sticky = require("semantic-ui-sticky");

const Toc: React.FC<any> = ({ headers, parentMap }) => {
  // const Toc: React.FC<any> = (headers) => {
  const { id } = React.useContext(TocContext);

  const indentAmount = 0.5;

  // const vh = window? window.innerHeight - 120: 0;

  const isActive = (itemid: string, currentid: string): boolean => {
    if (itemid === currentid) return true;
    const ids = parentMap[currentid];
    return ids && ids.includes(itemid);
  };

  return (
    <div
      id="toc"
      style={{
        // maxWidth: 320,
        // maxHeight: 400
        overflowY: 'auto',
        // height: vh>0?vh:`1vh`
      }}
    >
      <Menu
        // pointing
        // secondary
        inverted
        // floated={'right'}
        compact
        vertical
        width={4}
        // fixed={"left"}
        size={'mini'}
        // tabular={"right"}
        style={
          {
            // overflow: 'auto',
            // top: 50,
            // margin: 10
          }
        }
      >
        <Menu.Item
          color={'red'}
          // fitted
          header
        >
          目次
        </Menu.Item>
        {headers.map((item: HeaderItem) => {
          return (
            <Menu.Item
              key={item.id}
              name={item.id}
              active={isActive(item.id, id)}
              href={`#${item.id}`}
              style={{
                padding: `0.5em 1em 0.5em ${1 +
                  (item.depth - 2) * indentAmount}em`,
                fontWeight: `${item.depth === 2 ? '700' : '300'}`,
              }}
            >
              {/*<Icon name="play" /> {` ${item.name}`}*/}
              <Icon
                name="angle right"
                style={{ float: 'left' }}
                size={'mini'}
              />{' '}
              {item.name}
            </Menu.Item>
          );
        })}
      </Menu>
    </div>
  );
};

export default Toc;
